import axios from "axios";
import React, { useState } from "react";
import { WORKSHOP_ID } from "../../../constants";
import { toast } from "react-toastify";
import useThemeColors from "../../vehicle/ThemeColors";
import { useNavigate } from "react-router-dom";

interface IPROPS {
  closeModal: any;
  // refetch:any
  requestedId: any;
}

const CancelServiceRequest: React.FC<IPROPS> = ({
  closeModal,
  requestedId,
}) => {
  const [textArea, setTextArea] = useState("");

  const fetchingTenant = window.location.hostname.split(".")[0];
  const apiPort = process.env.REACT_APP_API_PROTOCOL;
  const getWorkshopId = localStorage.getItem(WORKSHOP_ID);

  const navigate = useNavigate();

  const cancelServiceRequest = async (e) => {
    e.preventDefault();

    const bookingServicePayload = {
      status: "cancelled",
      service_reply: textArea,
      user_id: getWorkshopId,
    };

    try {
      const response = await axios.post(
        `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/gc/workshop-booking-requests/${requestedId}/update_status/`,
        bookingServicePayload
      );

      if (response?.data) {
        toast.success(response?.data?.message);

        // setIsCheckoutClicked(false)
        sessionStorage.clear();
        // refetch()
        // setCartItems([])
        closeModal();
        navigate("/vehicle/service-request");
      }
    } catch (error) {
      toast.error("An error occured");
    }
  };

  const { selectedButtonBackgoundColors, selectedButtonColors } =
    useThemeColors();

  return (
    <div
      style={{
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      <div style={{ display: "flex", justifyContent: "center" }}>
        <label
          style={{
            fontSize: "20px",
            fontWeight: "200",
            fontFamily: "Karbon-medium",
          }}
        >
          Cancel Appointment
        </label>
      </div>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <label
          style={{ fontFamily: "Karbon", fontSize: "13px", color: "#333333" }}
        >
          Reason
        </label>
        <textarea
          onChange={(e) => setTextArea(e.target.value)}
          value={textArea}
          placeholder="Enter Reason"
          style={{ fontFamily: "karbon" }}
        />
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <button
          onClick={cancelServiceRequest}
          type="submit"
          style={{
            width: "100%",
            padding: "10px 25px",
            borderRadius: "20px",
            // background: `${selectedButtonBackgoundColors}`,
            // color: `${selectedButtonColors}`,
            // border: `1px solid ${selectedBorderColor}`,
            whiteSpace: "nowrap",
            background: `${selectedButtonBackgoundColors}`,
            color: `${selectedButtonColors}`,
            border: "none",
            // padding: "10px 20px",
            // borderRadius: "20px",
            fontSize: "13px",
            fontFamily: "Karbon",
          }}
        >
          Cancel Service
        </button>
      </div>
    </div>
  );
};

export default CancelServiceRequest;
